module.exports = __webpack_public_path__ + "img/Prefootball_Game_Library.6949c860.png";